/**
 * Copyright (c) 2020 Honeywell International Inc. All Rights Reserved.
 * Honeywell and its product names are among the trademarks and/or service marks owned
 * by Honeywell International, Inc., or its subsidiaries.
 *
 * For patent information, see http://www.hsmpats.com.
 */

import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Grid, Input, Button, Icon, Tooltip } from '@scuf/common';
import Moment from 'moment';
import 'moment-timezone';
import Validator from 'validator';
import { util } from '@keystone/common';
import Routes from '../../common/routes';
import InlineError from '../components/InlineError';
import { withVadContext, withApplicationContext } from '../../common/HOCs';

class CreateSLA extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {
        customerName: '',
        customerEmail: '',
        partnerEmail: '',
        cbmemail: '',
        status: 'Outstanding',
        timeCreated: Moment(new Date()).unix(),
      },
      loading: false,
      errors: {},
    };
  }

  customerNameChange = (customerName) => {
    const { data } = this.state;
    this.setState({ data: { ...data, customerName } });
  };

  customerEmailChange = (customerEmail) => {
    const { data } = this.state;
    this.setState({ data: { ...data, customerEmail } });
  };

  partnerEmailChange = (partnerEmail) => {
    const { data } = this.state;
    this.setState({ data: { ...data, partnerEmail } });
  };

  CBMemailChange = (cbmemail) => {
    const { data } = this.state;
    this.setState({ data: { ...data, cbmemail } });
  };

  onClick = async () => {
    const { vadContext, history } = this.props;
    const { data } = this.state;
    const errors = this.validate(data);
    this.setState({ errors });

    if (Object.keys(errors).length === 0) {
      this.setState({ loading: true });
      const response = await vadContext.createSLA(data);
      if (!(response instanceof Error)) {
        history.push({ pathname: Routes.SLATable });
      }
      this.setState({ loading: false });
    }
  };

  validate = (data) => {
    const errors = {};

    if (!data.customerName) errors.customerName = 'Customer Name cannot be empty;';
    if (!data.customerEmail || !Validator.isEmail(data.customerEmail))
      errors.customerEmail = 'Invalid Customer Email;';
    if (!data.partnerEmail || !Validator.isEmail(data.partnerEmail))
      errors.partnerEmail = 'Invalid Partner Email;';
    if (!data.cbmemail || !Validator.isEmail(data.cbmemail))
      errors.cbmemail = 'Invalid Honeywell Business Manager Email;';

    return errors;
  };

  render() {
    const { history, appContext } = this.props;
    const { data, errors, loading } = this.state;
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={12}>
            <Grid className="contact-us-area">
              <Grid.Row>
                <Grid.Column width={12}>
                  <h1>Create SLA</h1>
                </Grid.Column>
                {errors.customerName && <InlineError text={errors.customerName} />}
                &nbsp;
                {errors.customerEmail && <InlineError text={errors.customerEmail} />}
                &nbsp;
                {errors.partnerEmail && <InlineError text={errors.partnerEmail} />}
                &nbsp;
                {errors.cbmemail && <InlineError text={errors.cbmemail} />}
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={6}>
                  <Input
                    fluid
                    label="Customer Name"
                    indicator="required"
                    placeholder="Name"
                    value={data.customerName}
                    onChange={(input) => this.customerNameChange(input)}
                  />
                </Grid.Column>
                <Grid.Column width={6}>
                  <Input
                    fluid
                    label="Customer Email"
                    indicator="required"
                    placeholder="example@example.com"
                    value={data.customerEmail}
                    onChange={(input) => this.customerEmailChange(input)}
                  />
                </Grid.Column>
                <Grid.Column width={6}>
                  <Input
                    fluid
                    label="Partner Email"
                    indicator="required"
                    placeholder="example@example.com"
                    value={data.partnerEmail}
                    onChange={(input) => this.partnerEmailChange(input)}
                  />
                </Grid.Column>
                <Grid.Column width={6}>
                  <Input
                    fluid
                    label="Honeywell Representative (CBM/BDM)"
                    indicator="required"
                    placeholder="example@honeywell.com"
                    value={data.cbmemail}
                    onChange={(input) => this.CBMemailChange(input)}
                  />
                </Grid.Column>
                <Grid.Column width={2}>
                  <p>
                    Status: <b>{data.status}</b>
                  </p>
                </Grid.Column>
                <Grid.Column width={6}>
                  SLA
                  <a
                    onClick={() => null}
                    href={
                      `${util.getAPIGatewayURL()}/vactool/admin/getSLA` +
                      `?id_token=${appContext.user.idToken}` +
                      `&fileName=` +
                      `&ext=pdf`
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Tooltip
                      element={<Icon name="document" size="large" />}
                      content="SLA Document"
                      position="top right"
                    />
                  </a>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={12}>
                  <Button
                    type="primary"
                    content="Submit"
                    loading={loading}
                    onClick={this.onClick}
                  />
                  <Button
                    type="secondary"
                    content="Cancel"
                    onClick={async () => {
                      history.push({ pathname: Routes.SLATable });
                    }}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default withRouter(withApplicationContext(withVadContext(CreateSLA)));
